import React from 'react';
import { Fragment } from "react";
import SelectAsync from 'react-select/async'
import { components } from "react-select"
import Icon from '@mdi/react'
import { mdiSearchWeb } from '@mdi/js'
import { inputStyles } from './Constants'
import I18N from '../classes/I18N'
import translations from '../lang/components/ListingSelector.lang.json'

const i18n = new I18N(translations);

const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <Icon path={mdiSearchWeb} size={1} />
      </components.DropdownIndicator>
    );
};

const SingleValue = props => {
    const { children, ...rest } = props;
    const { selectProps } = props;
    let contents = children;

    if (selectProps.menuIsOpen) {
        contents = selectProps.placeholder ? (
            <div style={{ color: "#999" }}>{selectProps.placeholder}</div>
        ) : (
            <Fragment/>
        );
    }

    return <components.SingleValue {...rest}>{contents}</components.SingleValue>;
}

class ListingSelector extends React.Component {
    constructor(props) {
      super(props);
      this.handleChange = this.handleChange.bind(this);
    }

    loadListings = (search) => {
      return fetch(`${process.env.REACT_APP_KVCORE_API_URI}/v2/internal/clm/marketing/templates/elastic-listings?showManual=true&order=listingdate|desc${search !== '' ? '&search=' + search : '' }`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${this.props.jwt}`
            }
        }).then(response => response.json()).then(data => data.data)
    };

    handleChange = (newValue) => {
        if (newValue?.manual) {
            this.props.onListingChange(newValue);
        } else {
            const query = {
                forDisplay: 1,
                useElastic: 1
            };

            if (newValue?.is_sold_data) {
                query.isSold = 1;
            }

            fetch(
                `${process.env.REACT_APP_KVCORE_API_URI}/listings/${newValue.mls}/${newValue.mlsid}?${(new URLSearchParams(query)).toString()}`, {
                    method: 'GET',
                    headers: {
                      'Authorization': `Bearer ${this.props.jwt}`
                    }
                }).then(response => response.json()).then(data => {
                    this.props.onListingChange(data.data);
                })
        }
    }

    render() {
      return (

        <div>
            <div style={{display: "flex", marginBottom: "20px"}}>
                <div style={{display: "grid", marginRight: "14px"}}>
                    <svg className={"icons-color"} style={{alignSelf: "center"}} width="20" height="17" viewBox="0 0 20 18" stroke="currentColor" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 17.5V11.5H12V17.5H17V9.5H20L10 0.5L0 9.5H3V17.5H8Z"/>
                    </svg>
                </div>
                <div style={{fontSize: "18px", color: "#444444"}}>
                    {i18n.t(this.props.locale, 'listing')}
                </div>
            </div>
            <div style={{fontSize: "13px"}}>{i18n.t(this.props.locale, 'selectListing')}</div>
            { this.props.preload
              ? (
                  <SelectAsync
                      classNamePrefix="react-select"
                      components={{DropdownIndicator, SingleValue}}
                      placeholder={i18n.t(this.props.locale, 'placeholder')}
                      noOptionsMessage={ () => i18n.t(this.props.locale, 'noOptions') }
                      loadingMessage={ () => i18n.t(this.props.locale, 'loading') }
                      getOptionLabel={(option) => `${option.address} ${option.city} ${option.state}, ${option.zip}`}
                      getOptionValue={(option) => option.manual ? `manual-${option.id}` : option.mlsid}
                      loadOptions={this.loadListings}
                      defaultOptions={true}
                      onChange={this.handleChange}
                      styles={inputStyles}
                      value={this.props.preload ? this.props.preloadedListing : null}
                  />)
              : (
                  <SelectAsync
                      classNamePrefix="react-select"
                      components={{DropdownIndicator, SingleValue}}
                      placeholder={i18n.t(this.props.locale, 'placeholder')}
                      noOptionsMessage={ () => i18n.t(this.props.locale, 'noOptions') }
                      loadingMessage={ () => i18n.t(this.props.locale, 'loading') }
                      getOptionLabel={(option) => `${option.address} ${option.city} ${option.state}, ${option.zip}`}
                      getOptionValue={(option) => option.manual ? `manual-${option.id}` : option.mlsid}
                      loadOptions={this.loadListings}
                      defaultOptions={true}
                      onChange={this.handleChange}
                      styles={inputStyles}
                  />)
            }
        </div>
      );
    }
  }

  export default ListingSelector;
